/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as CommunicationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.communication.createTemplate'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  name: /*#__PURE__*/ l.string(),
  contentMarkdown: /*#__PURE__*/ l.string(),
  subject: /*#__PURE__*/ l.string(),
  lang: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'language' }),
  ),
  createdBy: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<CommunicationDefs.TemplateView>(
    (() => CommunicationDefs.templateView) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Administrative action to create a new, re-usable communication (email for now) template. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'DuplicateTemplateName',
])

export { main }

export const $lxm = $nsid
